import styled from 'styled-components';
import { StyledContainer as Container } from '../Container/container.styles';

export const StyledHeader = styled.header`
  width: 100%;
  background-color: ${({ theme }) => theme.palette.common.white};
`;
export const StyledContainer = styled(Container)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0;
  padding-bottom: 32px;
`;
